















import { Component, Vue, Prop } from 'nuxt-property-decorator'
import BlogItem from '~/components/Blog/BlogItem.vue'

@Component({
  name: 'BlogList',
  components: { BlogItem }
})
export default class extends Vue {
  @Prop() list
}
